<template>
  <div class="budget-preparation">
    <SimpleTable
      ref="budgetPreparation"
      table-code="budgetPreparation"
      :menus="['查询', '批量修改', '插入', '批量删除']"
      :rightFrozenColCount="1"
      :columns="columns"
      :data="tableData"
      :loading="loading"
      @modify-data-change="onModifyDataChange"
    />

    <DesignDetail ref="designDetail" @close="getTableData" />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, getOptions, addCbFn } from '@/utils/index'
import DesignDetail from './DesignDetail.vue'

export default {
  name: 'BudgetPreparation',
  mixins: [tableMixin],
  components: {
    SimpleTable,
    DesignDetail
  },
  data() {
    return {
      tableData: [],
      columns: [
        { field: 'name', title: '预算名称', canEdit: true, canModify: true },
        {
          field: 'dbeName',
          title: '设计概算',
          editModal: {
            columns: [{ field: 'name', title: '设计概算' }],
            options: async () => {
              const res = await this.$service.get(
                '/design-budget-estimate/list'
              )
              return res?.data || []
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'dbeName', row.name)
                this.$set(obj, 'dbeId', row.id)
              })
            }
          },
          canModify: true
        },
        { field: 'projectName', title: '项目名称' },
        { field: 'projectType', title: '项目类型' },
        { field: 'regionName', title: '所在区域' },
        { field: 'address', title: '详细地址' },
        { field: 'measurementUnit', title: '计量单位' },
        { field: 'constructionScale', title: '建筑规模' },
        {
          field: 'estimateAmount',
          title: '预算金额',
          width: 100
        },
        {
          field: 'sysCreatedDate',
          title: '编制日期',
          editor: { type: 'date' }
        },
        {
          field: 'operation',
          title: '操作',
          width: 40,
          cellType: 'text',
          buttons: [
            {
              action: 'import',
              text: '编制预算',
              click: (row, record) => {
                this.import(row, record)
              }
            }
          ]
        }
      ],
      loading: false
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      this.loading = true
      const res = await this.$service.get('/construction-budget-estimate/list')
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    import(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.designDetail.show(this.tableData[row])
    },

    async onModifyDataChange(getModifyData, cleanModifyData) {
      await addCbFn(
        this.$service,
        '/construction-budget-estimate/batch',
        getModifyData,
        cleanModifyData
      )

      this.getTableData()
    }
  }
}
</script>

<style scoped lang="less">
.budget-preparation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
